<div class="_content bg-col-w z-2"
     #cmsNode>
    @if (content) {
    <div class="flex-column height-100 overflow-hidden pos-relative">
        <!-- top section -->
        <div class="p-a-4 flex flex-middle flex-justify-between b-b b-col-5">
            <div class="_search flex-grow flex no-wrap">
                <div class="w-12 m-r-4">
                    <page-off-canvas-search-form></page-off-canvas-search-form>
                </div>

            </div>

            <button class="_navButton _back"
                    role="button"
                    aria-label="Close"
                    (click)="back()">
                <i class="icon-arrow-left inline-flex"
                   aria-hidden="true"></i>
            </button>
            <!-- title -->
            <p class="s1 p-l-2 p-r-2 center"
               *ngIf="menuTitles[level.getValue()]">{{menuTitles[level.getValue()]}}</p>
            <!-- close button -->
            <button class="_navButton"
                    role="button"
                    aria-label="Close"
                    (click)="close()">
                <i class="icon-close inline-flex"
                   aria-hidden="true"></i>
            </button>
        </div>
        <!-- body -->
        <div class="_body flex-grow p-b"
             [class.custom-scrollbar]="!client.isTouchy">
            <div #stage
                 [toggleClass]="'_hiddenStage'"
                 [toggleClassBy]="[toggleGroupId, searchMeganavKey]"
                 class="_stage _fadeInStage">
                <!-- menus -->
                <page-off-canvas-menu [component]="content"
                                      [level]="0">
                    <div class="p-a flex flex-middle">
                        <p class="p1 m-r-2">{{'VAT'| translate}}: </p>
                        <toggle class="bg-col-57">
                            <input type="checkbox"
                                   [(ngModel)]="vatSelected"
                                   (ngModelChange)="toggleVat()"
                                   [name]="'toggle'" />
                        </toggle>
                    </div>
                    <!-- bottom links -->
                    <ul class="p-a">
                        <!-- Login -->
                        <href [link]="'/login'">
                            <div class="p-a bg-col-51 b-a b-col-5 b-radius-4 flex flex-middle">
                                <i class="icon-account inline-flex m-r-2"></i>
                                <span class="p2">
                                    {{ (app.customer.model?.isLoggedIn ? 'Account' : 'Sign in') | translate }}
                                </span>
                            </div>
                        </href>
                        @for (item of content.navigationMenu; track $index) {
                        <href [link]="item.link">
                            <div class="p-a bg-col-51 b-a b-col-5 b-radius-4 flex flex-middle m-t">
                                @if (item.icon) {
                                <i [ngClass]="item.icon"
                                   class="inline-flex m-r-2"></i>
                                }
                                <span class="p2"
                                      *iCms="'text' of item">
                                </span>
                            </div>
                        </href>
                        }

                        @if(!content.hideTab) {
                        <div class="p-a-2 b-radius-4 bg-col-51 b-a b-col-5 m-t flex">
                            @if(content.firstTabImage) {
                            <href class="bg-col-w w-4 m-r-1 b-radius-4 b-a flex flex-justify-center p-t-3 p-b-3"
                                  [ngClass]="content.firstActivated ? 'b-col-6': 'b-col-5'"
                                  [link]="content.firstTabLink || '/'"
                                  [hrefTarget]="'_self'"
                                  [hrefOff]="content.firstActivated">

                                <img [width]="63"
                                     [height]="21"
                                     [loaderParams]="{fitIn: true}"
                                     [dfImage]="content.firstTabImage">

                            </href>
                            }
                            @if(content.secondTabImage) {
                            <href class="bg-col-w w-4 m-l-1 b-radius-4 b-a flex flex-justify-center p-t-3 p-b-3"
                                  [ngClass]="!content.firstActivated ? 'b-col-6': 'b-col-5'"
                                  [link]="content.secondTabLink || '/'"
                                  [hrefTarget]="'_self'"
                                  [hrefOff]="!content.firstActivated">

                                <img [width]="63"
                                     [height]="21"
                                     [loaderParams]="{fitIn: true}"
                                     [dfImage]="content.secondTabImage">

                            </href>
                            }
                            @if(content.thirdTabImage) {
                            <href class="bg-col-w w-4 m-l-1 b-radius-4 b-a b-col-5 flex flex-justify-center p-t-3 p-b-3"
                                  [link]="content.thirdTabLink || '/'"
                                  [hrefTarget]="'_blank'">

                                <img [width]="63"
                                     [height]="21"
                                     [loaderParams]="{fitIn: true}"
                                     [dfImage]="content.thirdTabImage">

                            </href>
                            }
                        </div>
                        }

                        <href class="w-12 m-t ratio-1-1 _bannerImage b-radius-4"
                              [link]="content.bannerLink">

                            <img [ratio]="1"
                                 [dfImage]="content.bannerImage"
                                 [fill]="true"
                                 class="b-radius-4">
                            <div class="pos-absolute bottom-0 w-12 z-1 p-a">
                                <p class="h3 col-w m-b-2 yes-wrap"
                                   *iCms="'bannerText' of content"></p>
                                <button [buttonStyle]>
                                    <span *iCms="'bannerButtonCopy' of content"></span>
                                </button>
                            </div>
                        </href>
                    </ul>
                </page-off-canvas-menu>
            </div>
            <!-- search -->
            <div [toggleClass]="'!_hiddenStage'"
                 class="_fadeInStage"
                 [toggleClassBy]="searchToggleId">
                <page-search-outlet class="p-b-8"></page-search-outlet>
            </div>
        </div>
        <div class="w-12 bg-col-6 p-a-2 flex flex-justify-between"
             [class._hiddenStage]="level.getValue() !== 0"
             style="border-radius: 4px, 4px, 0px, 0px">
            <button [iCmsModalOpen]="DELIVERY_MODAL_ID"
                    class="w-6 m-r-1 flex flex-middle flex-justify-center p-a-1 bg-col-61 m-r-1"
                    style="border-radius: 4px">
                <i class="m-r-1 inline-flex icon-delivery"
                   style="font-size: 16px"></i>
                <span class="p2 inline-block va-m">{{'Delivery address' | translate}}
                </span>
            </button>
            <button [iCmsModalOpen]="BRANCH_MODAL_ID"
                    class="w-6 m-r-1 flex flex-middle flex-justify-center p-a-1 bg-col-61 m-l-1"
                    style="border-radius: 4px">
                <i class="m-r-1 inline-flex icon-collection"
                   style="font-size: 16px"></i>
                <span class="p2 inline-block va-m">{{'Collection branch' | translate}}
                </span>
            </button>
        </div>
    </div>
    }
</div>


<!-- overlay -->
<overlay class="z-1"
         (click)="close(true)"
         [visible]="offCanvasState"></overlay>
